
  import ScreenSize from '@/mixins/ScreenSize';
  import Events from '@/events/Events';
  import DialogsBaseSection from '@/components/sections/DialogsBaseSection.vue';
  import RegistrationOAuth from '@/mixins/RegistrationOAuth';

  export default {
    name: 'CheckEmailForm',
    components: {
      DialogsBaseSection,
      RichText: () => import('@/components/elements/RichText'),
    },
    mixins: [RegistrationOAuth, ScreenSize],
    props: {
      position: {
        type: String,
        required: false,
        default: 'NULL',
      },
      job: {
        type: Object,
        required: false,
        default: () => {},
      },
    },
    data() {
      return {
        email: '',
        error: null,
        section: {},
      };
    },
    async fetch() {
      const strapiSingleType = this.job
        ? 'registration-before-application-dialog'
        : 'registration-or-login-dialog';
      const section = await this.$cachedStrapi
        .find(strapiSingleType)
        .catch((e) => {
          if (e.statusCode !== 404) {
            throw e;
          }
        });
      this.section = {
        title: section.email_check_title,
        subline: section.email_check_subline,
        intro_text: section.email_check_intro_text,
        button_text: section.email_check_button_text,
        google_registration: section.google,
        facebook_registration: section.facebook,
        apple_registration: section.apple,
        microsoft_registration: section.microsoft,
      };
    },
    computed: {},
    methods: {
      sendMatomoEvent(type) {
        if (type === 'facebook') {
          this.$emitWithClientData(
            this.job
              ? Events.RegistrationBeforeApplicationSwitchToFacebook
              : Events.RegistrationOrLoginSwitchToFacebook,
            {
              type: 'EmailCheck',
              jobPostingId: this.job?.id,
            }
          );
        } else if (type === 'google') {
          this.$emitWithClientData(
            this.job
              ? Events.RegistrationBeforeApplicationSwitchToGoogle
              : Events.RegistrationOrLoginSwitchToGoogle,
            {
              type: 'EmailCheck',
              jobPostingId: this.job?.id,
            }
          );
        } else if (type === 'apple') {
          this.$emitWithClientData(
            this.job
              ? Events.RegistrationBeforeApplicationSwitchToApple
              : Events.RegistrationOrLoginSwitchToApple,
            {
              type: 'EmailCheck',
              jobPostingId: this.job?.id,
            }
          );
        } else {
          this.$emitWithClientData(
            this.job
              ? Events.RegistrationBeforeApplicationSwitchToMicrosoft
              : Events.RegistrationOrLoginSwitchToMicrosoft,
            {
              type: 'EmailCheck',
              jobPostingId: this.job?.id,
            }
          );
        }
      },
      checkEmail() {
        this.$store
          .dispatch('api/candidateProfile/emailCheck', {email: this.email})
          .then(async (res) => {
            if (res.status === 204) {
              await this.$emit('set-current-email', this.email);
              this.$emitWithClientData(
                this.job
                  ? Events.RegistrationBeforeApplicationStepFinished
                  : Events.RegistrationOrLoginStepFinished,
                {
                  step: 'EmailCheck',
                  jobPostingId: this.job?.id,
                }
              );
              await this.$emit('change-dialog-page', 'registration');
              this.resetDialog();
            }
          })
          .catch((e) => {
            if (
              e &&
              e.response &&
              e.response.status &&
              e.response.status === 422
            ) {
              e.response.data.violations.map(async (violation) => {
                if (violation.code === 'cfa413b8-15b5-ea18-9642-a592dda56451') {
                  await this.$emit('set-current-email', this.email);
                  this.$emitWithClientData(
                    this.job
                      ? Events.RegistrationBeforeApplicationStepFinished
                      : Events.RegistrationOrLoginStepFinished,
                    {
                      step: 'EmailCheck',
                      jobPostingId: this.job?.id,
                    }
                  );
                  await this.$emit('change-dialog-page', 'login');
                  this.resetDialog();
                }
                if (violation.code === 'b11a5bb8-8866-631a-2305-70d305b4b143') {
                  this.$notifications.showNotification({
                    message: this.$t(
                      'action.registration_or_login_reg_error_org_email'
                    ),
                    color: 'error',
                    timeout: 5000,
                  });
                }
              });
            }
          });
      },
      resetDialog() {
        this.email = '';
      },
    },
  };
